const kBtoBytes = (kB: number): number => kB * 1024;

export default kBtoBytes;
